import { Theme } from '@mui/material';
import { getSidenavHoverBackground, getSidenavTextColor } from '../../sidenav-colors';
import { SIDENAV_TOKENS } from '../../sidenav-tokens';

/** Outer SidenavRow packing for the account trigger. */
export function getAccountRowSx(avatarPaddingLeft: number) {
  const tokens = SIDENAV_TOKENS;

  return {
    height: tokens.accountRowHeight,
    minHeight: tokens.accountRowHeight,
    justifyContent: 'flex-start',
    alignItems: 'center',
    mt: 1,
    pl: `${avatarPaddingLeft}px`,
    pr: tokens.contentPaddingX,
  };
}

type AccountTriggerSxOptions = {
  collapsed: boolean;
  menuOpen: boolean;
};

/** Full-width ButtonBase that opens the account popover. */
export function getAccountTriggerSx(
  theme: Theme,
  { collapsed, menuOpen }: AccountTriggerSxOptions,
) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 1,
    flex: collapsed ? undefined : 1,
    width: collapsed ? undefined : '100%',
    minWidth: 0,
    background: menuOpen ? getSidenavHoverBackground(theme) : 'transparent',
    borderRadius: 1,
    color: getSidenavTextColor(theme),
    py: 0.5,
    px: 0,
    '&:hover': {
      background: getSidenavHoverBackground(theme),
    },
  };
}

/** Stacked client + user name column next to the avatar. */
export const accountTextColumnSx = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'left',
  gap: '1px',
} as const;

/** Client/org caption above the user name. */
export const accountClientLineSx = {
  typography: 'caption',
  fontSize: '0.625rem',
  lineHeight: '14px',
  opacity: 0.7,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

/** Primary user display name in the rail. */
export function getAccountUserLineSx() {
  return {
    typography: 'body2',
    fontSize: SIDENAV_TOKENS.fontSize,
    lineHeight: '17px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  } as const;
}

/** Chevron hint that the account row opens a menu. */
export const accountChevronSx = {
  fontSize: 16,
  opacity: 0.7,
  flexShrink: 0,
} as const;
